import Basic from './basic';

const MEDIA = {
  'WECHAT': 1,
  'WEIBO': 2,
  'REDBOOK': 3,
  'TIKTOK': 4,
  'BILIBILI': 5,
  'KWAI': 6,
  'TAOBAO': 7
}

const MONITOR_STATUS = {
  // UnMonitored: 0,
  WaitMonitor: 0,
  InMonitor: 1,
  CompleteMonitor: 2
}

const WEIBO_AT = {
  Original: 0,
  Forward: 1,
  Video: 2
}

const CONFIG = {
  "media_ch": {
    [MEDIA.WECHAT]: "微信",
    [MEDIA.WEIBO]: "微博",
    [MEDIA.REDBOOK]: "小红书",
    [MEDIA.TIKTOK]: "抖音",
    [MEDIA.BILIBILI]: "B站",
    [MEDIA.KWAI]: "快手",
    [MEDIA.TAOBAO]: "淘宝直播"
  },
  "media_en": {
    [MEDIA.WECHAT]: "wechat",
    [MEDIA.WEIBO]: "weibo",
    [MEDIA.REDBOOK]: "redbook",
    [MEDIA.TIKTOK]: "tiktok",
    [MEDIA.BILIBILI]: "bilibili",
    [MEDIA.KWAI]: "kwai",
    [MEDIA.TAOBAO]: "taobao"
  },
  "monitor_status": {
    // [MONITOR_STATUS.UnMonitored]: "未监测",
    [MONITOR_STATUS.WaitMonitor]: "待监测",
    [MONITOR_STATUS.InMonitor]: "监测中",
    [MONITOR_STATUS.CompleteMonitor]: "监测完毕"
  },
  "weibo_article_types": {
    [WEIBO_AT.Original]: "直发",
    [WEIBO_AT.Forward]: "转发",
    [WEIBO_AT.Video]: "视频"
  }
}

let mediaConfig = new Basic(CONFIG);
mediaConfig.MEDIA = MEDIA;
mediaConfig.MonitorStatus = MONITOR_STATUS;
mediaConfig.WeiboArtType = WEIBO_AT;

export { mediaConfig }